"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncMessageFactory = exports.actionName = void 0;

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

/**
 * Generates an action type constant given a domain and action name, will automatically uppercase the input
 * to conform to Flux Standard Actions
 * @param {string} domain - name of the domain
 * @param {string} namespace - name of the action
 * @returns {String} - uppercase string
 */
var actionName = function actionName(domain, namespace) {
  return "".concat(domain.toUpperCase(), "_").concat(namespace.toUpperCase());
};
/**
 * Creates a message factory bound to a particular domain. The factory will accept an action type and generate
 * an object containing `begin` and `end` actions to be used for asynchronous flows.
 * @param {string} domain - name of the domain
 * @returns {Function} - a factory function which will return an object containing begin/end string properties
 */


exports.actionName = actionName;

var asyncMessageFactory = function asyncMessageFactory(domain) {
  return function (namePrefix) {
    return {
      START: actionName(domain, "".concat(namePrefix, "_BEGIN")),
      END: actionName(domain, "".concat(namePrefix, "_END")),
      ERROR: actionName(domain, "".concat(namePrefix, "_ERROR")),
      SUCCESS: actionName(domain, "".concat(namePrefix, "_SUCCESS"))
    };
  };
};

exports.asyncMessageFactory = asyncMessageFactory;